import React from 'react';
import { popularDestinations } from '../data/mock';
import { MapPin, ArrowRight } from 'lucide-react';
import { Button } from './ui/button';

const Destinations = () => {
  return (
    <section id="destinations" className="py-16 md:py-24 bg-gradient-to-b from-white to-amber-50/30">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1 bg-amber-100 text-amber-700 rounded-full text-sm font-medium mb-4">
            Popular Destinations
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-slate-800 mb-4">
            Explore South India With Us
          </h2>
          <p className="text-slate-600 max-w-2xl mx-auto">
            Plan your journey with us to some of the most popular destinations. Custom itineraries available on request.
          </p>
        </div>

        {/* Destinations Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
          {popularDestinations.map((destination, index) => (
            <div 
              key={destination.id}
              className={`group relative rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-all duration-300 cursor-pointer ${
                index === 0 || index === 5 ? 'md:row-span-2' : ''
              }`}
            >
              <div className={`relative ${
                index === 0 || index === 5 ? 'h-64 md:h-full' : 'h-48 md:h-52'
              }`}>
                <img
                  src={destination.image}
                  alt={destination.name}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent" />
                
                {/* Content Overlay */}
                <div className="absolute inset-0 p-4 flex flex-col justify-end">
                  <div className="flex items-start gap-1 text-amber-400 mb-1">
                    <MapPin className="w-4 h-4 mt-0.5 flex-shrink-0" />
                    <span className="text-xs font-medium">{destination.type}</span>
                  </div>
                  <h3 className="text-lg md:text-xl font-bold text-white group-hover:text-amber-300 transition-colors">
                    {destination.name}
                  </h3>
                </div>

                {/* Hover Overlay */}
                <div className="absolute inset-0 bg-amber-500/90 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <div className="text-center text-white">
                    <h3 className="text-xl font-bold mb-2">{destination.name}</h3>
                    <p className="text-amber-100 text-sm mb-4">{destination.type}</p>
                    <span className="inline-flex items-center gap-1 text-sm font-medium">
                      Plan Trip <ArrowRight className="w-4 h-4" />
                    </span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center mt-10">
          <Button className="bg-amber-500 hover:bg-amber-600 text-white px-8 py-6 text-lg rounded-xl shadow-lg shadow-amber-500/25">
            View All Destinations
            <ArrowRight className="w-5 h-5 ml-2" />
          </Button>
        </div>
      </div>
    </section>
  );
};

export default Destinations;
